/* eslint-disable */
import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/index.vue"
import { getMe } from "@/utils/accessToken";
// import Classroom from "../views/Classroom/List.vue"
import Layout from "../layout/index.vue"
import Login from "../views/Login/index.vue"
import User from "../router/user.js"
import Classroom from "../router/classroom.js"
import Slider from "../router/slider.js"
import Transaction from "../router/transaction"
import Coupon from "../router/coupon"
import Voucher from "../router/voucher"
import Notification from "../router/notification"
import WebinarPlus from "../router/webinarplus"
import PrivateWebinar from "../router/privateWebinar"

const routes = [{
        path: "/login",
        component: Login,
    },
    {
        path: "/",
        component: Layout,
        redirect: "/dashboard",
        children: [{
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                icon: "fas fa-tachometer-alt"
            }
        }, ]
    },
    {
        path: "/classroom",
        component: Layout,
        redirect: "/classroom",
        children: [{
                path: '',
                name: 'Classroom',
                component: () =>
                    import (
                        '@/views/Classroom/List.vue'
                    ),
                meta: {
                    title: "Classroom",
                    icon: "fas fa-school"
                }
            },
            ...Classroom
        ]
    },
    {
        path: "/user",
        component: Layout,
        redirect: "/user",
        children: [{
                path: '',
                name: 'User',
                component: () =>
                    import (
                        '@/views/User/List.vue'
                    ),
                meta: {
                    icon: "fas fa-users",
                    title: 'Users',
                }
            },
            ...User
        ]
    },

    {
        path: "/transaction",
        component: Layout,
        redirect: "/transaction",
        children: [{
                path: '',
                name: 'Transaction',
                component: () =>
                    import (
                        '@/views/Transaction/List.vue'
                    ),
                meta: {
                    icon: "fas fa-shopping-cart",
                    title: 'Transaction',
                }
            },
            ...Transaction
        ]
    },
    {
        path: "/blast",
        component: Layout,
        redirect: "/blast",
        children: [{
                path: '',
                name: 'Blast Promo',
                component: () =>
                    import (
                        '@/views/Notification/List.vue'
                    ),
                meta: {
                    icon: "far fa-bell",
                    title: 'Blast Promo Notification (Android)'
                }
            },
            // ...Notification
        ]
    },
    {
        path: "/certificate",
        component: Layout,
        redirect: "/certificate",
        children: [{
                path: '',
                name: 'Certificate',
                component: () =>
                    import (
                        '@/views/Certificate/List.vue'
                    ),
                meta: {
                    icon: "fas fa-award",
                    title: 'Certificate',
                }
            },
            {
                path: '/certificate/old-certificate',
                name: 'OldCertificate',
                component: () =>
                    import (
                        '@/views/Certificate/ListOld.vue'
                    ),
                meta: {
                    icon: "fas fa-certificate",
                    title: 'Old Certificate',
                }
            },

        ]
    },
    {
        path: "/voucher",
        component: Layout,
        redirect: "/voucher",
        children: [{
                path: '',
                name: 'Voucher, Kupon & Paket Webinar',
                component: () =>
                    import (
                        '@/views/Voucher/List.vue'
                    ),
                meta: {
                    icon: "coupon.svg",
                    title: 'Voucher Classroom',
                }
            },
            ...Voucher
        ]
    },
    {
        path: "/coupon",
        component: Layout,
        redirect: "/coupon",
        children: [{
                path: '',
                name: 'Coupon',
                component: () =>
                    import (
                        '@/views/Coupon/List.vue'
                    ),
                meta: {
                    icon: "fas fa-ticket-alt",
                    title: 'Coupon',
                }
            },
            ...Coupon
        ]
    },
    {
        path: "/slider",
        component: Layout,
        redirect: "/slider",
        children: [{
                path: '',
                name: 'Slider',
                component: () =>
                    import (
                        '@/views/Slider/List.vue'
                    ),
                meta: {
                    icon: "far fa-images",
                    title: 'Slider'
                }
            },
            ...Slider
        ],



    },
    {
        path: '/room',
        component: Layout,
        redirect: '/room',
        children: [{
                path: '',
                name: 'Room',
                component: () =>
                    import (
                        '@/views/Room/List.vue'
                    ),
                meta: {
                    icon: "fas fa-door-open",
                    title: 'List Room'
                }
            },
        ]
    },
    {
        path: '/webinar-plus',
        component: Layout,
        redirect: '/webinar-plus',
        children: [{
                path: '',
                name: 'Webinar Plus',
                component: () =>
                    import (
                        '@/views/WebinarPlus/Approved.vue'
                    ),
                meta: {
                    icon: "video-plus.svg",
                    title: 'List Approved Webinar Plus'
                }
            },
            ...WebinarPlus,
        ]
    },
    {
        path: '/webinar-quiz',
        component: Layout,
        redirect: '/webinar-quiz',
        children: [{
            path: '',
            name: 'Webinar Pre/Post-Test',
            component: () =>
                import (
                    '@/views/WebinarPrePostTest/List.vue'
                ),
            meta: {
                icon: 'webinar-quiz.svg',
                title: 'List Webinar Pre/Post-Test'
            }
        }]
    },
    {
        path: '/webinar-package',
        component: Layout,
        redirect: '/webinar-package',
        children: [
            {
                path: '',
                name: 'Paket Webinar',
                component: () =>
                    import(
                        '@/views/WebinarPackage/List.vue'
                    ),
                meta: {
                    icon: 'fas fa-layer-group',
                    title: 'Paket Webinar'
                }
            }
        ]
    },
    {
        path: '/private-webinar',
        component: Layout,
        redirect: '/private-webinar',
        children: [
            {
                path: '',
                name: 'Private Webinar',
                component: () =>
                    import(
                        '@/views/PrivateWebinar/Approved.vue'
                    ),
                meta: {
                    icon: 'fas fa-people-arrows',
                    title: 'List Approved Private Webinar'
                }
            },
            ...PrivateWebinar,
        ]
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
});


export default router;